import * as React from 'react'; // tslint:disable-line
import { Image } from '../image';
import { ImageProvider as Provider } from '@shapeable/web';

export const ImageProvider: React.FC<any> = ({ children }) => {
  return <Provider value={Image}>{children}</Provider>;
};